export const Messages = {
    emptyMessage: '',
    accountCreated: 'Your account has been created successfully. Please enter the code sent on your email to verify your account.',
    verificationCodeSuccess: 'Your email has been verified successfully. Please login.',
    passwordResetCode: 'The password reset code was sent to your email.',
    passwordChanged: 'Your password has been changed successfully.'
};